import React from "react";
import classNames from "classnames";

import FormGroup from "lib/components/FormControl/FormGroup";
import PlaceholderValueWrapper from "lib/components/PlaceholderValueWrapper";

export default function makeFormGroup(Component, defaults = {}) {
  return (props) => {
    const {
      name,
      error,
      valid = !error,
      label,
      inlineLabel,
      multipleFields,
      help,
      required,
      inputRequired = required,
      disabled,
      wrapperClassName,
      wrapperStyle,
      nullValue,
      placeholder,
      ...rest
    } = { ...defaults, ...props };

    const componentProps = {
      name,
      id: name,
      required: inputRequired,
      disabled,
      placeholder: nullValue || placeholder,
      ...rest,
    };
    const component = <Component {...componentProps} />;

    return (
      <FormGroup
        name={name}
        valid={valid}
        error={error}
        label={label}
        help={help}
        disabled={disabled}
        required={required}
        inline={inlineLabel}
        multipleFields={multipleFields}
        className={wrapperClassName}
        style={wrapperStyle}
      >
        {!nullValue && component}
        {nullValue && (
          <PlaceholderValueWrapper placeholder={nullValue} defaultPlaceholderVisible={rest.value === null}>
            {component}
          </PlaceholderValueWrapper>
        )}
      </FormGroup>
    );
  };
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/utils/makeFormGroup.js